<template>
  <div class="col-6 col-md filter-container">
    <h4>{{ I18n.t('search_page.artworks_tab.filters.category.title') }}</h4>
    <ul data-filter-group>
      <li v-for="artworkCat in artworksCategories">
        <button @click="changeFilters(artworkCat[0])"
                :class="{ 'filter--selected': isActive(artworkCat[0]) }"
                class="filter text-left" type="button">
          {{ artworkCat[1] }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
  import Helpers from '@/shared/mixins/artworks_filters_helpers';
  import { mapGetters, mapActions } from 'vuex';
  import { ARTWORKS_FILTERS } from '../../../consts';

  export default {
    name: 'CategoryFilterColumn',
    data() {
      return {
        path: ARTWORKS_FILTERS.CATEGORIES.PATH,
      };
    },
    computed: {
      ...mapGetters(['artworksCategories', 'filterValue']),
      activeValues() {
        return this.filterValue(this.path);
      },
    },
    mixins: [Helpers],
    methods: {
      ...mapActions(['getArtworksWhenFilterIsChanging']),
      changeFilters(value) {
        const updatedValues = this.updatedActiveValues(value);
        this.getArtworksWhenFilterIsChanging({ path: this.path, value: updatedValues });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/category_filter_column.vue?1cf650ea